import React, { useState, useEffect } from "react";

// Components
import { Image, Transformer } from "react-konva";

const TransformableLogoImage = ({
  frameOne,
  selectedFrame,
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  imageWidth,
  imageHeight,
  image,
  onMouseDown,
  onTouchStart,
}) => {
  // const [xaxis, setXaxis] = useState(28);
  // const [yaxis, setYaxis] = useState(160);
  // const [xAxisWidth, setXAxisWidth] = useState(180);
  // const [groupHeight, setGroupHeight] = useState(170);
  const [xaxis, setXaxis] = useState(105);
  const [yaxis, setYaxis] = useState(150);
  const [xAxisWidth, setXAxisWidth] = useState(170);
  const [groupHeight, setGroupHeight] = useState(170);
  const shapeRef = React.useRef();
  const trRef = React.useRef();
  const groupDimensions = {
    height: 130,
    width: 100,
  };
  const aspectRatio = imageWidth / imageHeight;
  const imageRenderWidth = aspectRatio * groupHeight;
  const imageRenderHeight = groupHeight;
  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  // useEffect(() => {
  //     if (selectedFrame === frameOne) {
  //         setXaxis(7)
  //         setYaxis(105)
  //         setXAxisWidth(159)
  //         setGroupHeight(118)
  //     } else {
  //         setXaxis(209.5)
  //         setYaxis(22)
  //         setXAxisWidth(150)
  //         setGroupHeight(119)
  //     }
  // }, [selectedFrame])
  return (
    <>
      <Image
        image={image}
        width={imageRenderWidth}
        x={xaxis}
        y={yaxis}
        height={imageRenderHeight}
        // onClick={onSelect}
        // onTap={onSelect}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        ref={shapeRef}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...shapeProps}
        // draggable
        onDragEnd={(e) => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={() => {
          if (shapeRef.current) {
            const node = shapeRef.current;
            onChange({
              ...shapeProps,
              x: node.x(),
              y: node.y(),
            });
          }
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};

export default TransformableLogoImage;
